import store from 'src/store';
import {
  setUserType,
  setAfterLogin,
  resetAfterLogin,
  setUrlAds,
  setContentDataPublicity,
  setProps,
  setKindOfPlayButtonAds
} from 'src/actions/ads';
import Utils from 'src/utils/Utils';
import Constants from 'src/AAF/Ads/Constans'
import NavExperienceTask from 'src/requests/tasks/ads/NavExperienceTask';
import RequestManager from 'src/requests/RequestManager';
import { setNodes } from 'src/actions/navbar';
import ExperienceHourRefresh from 'src/AAF/Ads/AdsTimer';
import { AAF_CONTENT_IS_VOD, RENT, BUY } from 'src/AAFPlayer/constants';
import Device from 'src/devices/device';
import CampaignTask from '../../requests/tasks/ads/CampaignTask';
import { getContentData } from 'src/components/Ficha/fichaHelper';

// Main utils
const getAdvertisingConfig = () =>{
    const ads=Utils.getRegionaliazedMetadata('cv_advertising_config', '{"default": { "enable": false}}');
    return ads;
}

const isAdsEnable = () => {
    const meta = getAdvertisingConfig();
    const isAdsEnabled = meta && meta.enable ? meta.enable : false;
    console.log(":::/isAdsEnable", meta.enable, meta.skip_offset);
    return isAdsEnabled && isTVPlatformSupported().support;
}


const getUserType = () => {
    const userType = store.getState().ads.userType;
    console.log(":::/checkUserType", userType);
    return userType;
};

const getSkipOffSet = () => {
    const meta = getAdvertisingConfig();
    const skip_offset = meta && meta.skip_offset? meta.skip_offset : 5;
    console.log(':::/skip_offset', skip_offset);
    return skip_offset;
};

const getexperience_hour_refresh = () => {
    const meta = getAdvertisingConfig();
    const experience_hour_refresh = meta && meta.experience_hour_refresh? meta.experience_hour_refresh : 0;
    console.log(':::/experience_hour_refresh', experience_hour_refresh);
    return experience_hour_refresh;
}

const loadUserType = async (redirectToHome) => {
    let result;
    let nav= getUserType();
    try {
        const task = new NavExperienceTask();
        result = await RequestManager.addRequest(task);
        if(result && result.data && result.data.nav_type){
            store.dispatch(setUserType(result.data.nav_type));
        }
        if (result && result.data && result.data.nodes){
            store.dispatch(setNodes(result.data.nodes));
        }
        ExperienceHourRefresh.setTimeoutExperience(nav, redirectToHome);
    } catch (error) {
        console.warn('Error calling UserAdsTask', error);
    }
}

const recibeProps=(history)=>{
    store.dispatch(setProps(history));
}

const getProps = () => {
    const props = store.getState().ads.props;
    console.log(":::/props", props);
    return props;
}

// Continue after login utils
const redirectToLogin = (history = null, props = {}) => {
    if (history) {
        store.dispatch(setAfterLogin({
            urlAfterLogin: history.location.pathname,
            propsAfterLogin: props,
        }));
        history.push({ pathname: '/login' });
    }
}

const redirectToRoot = (history, forceReset = false) => {
    if (history) {
        const url = getAfterLoginKeys().url;
        const props = getAfterLoginKeys().props;
        props && props.stateAL ?
            history.push({ pathname: url }, props.stateAL) :
            history.push({ pathname: url });
        forceReset && resetStateAfterLogin();
    }
}

const redirectToRootRegister = (history, forceReset = false) => {
    if (history) {
        const url = getAfterLoginKeys().url;
        const props = getAfterLoginKeys().props;

        if(props && props.stateAL){
            history.push(url, props.stateAL)
        }else{
            history.push(url);
        }
        forceReset && resetStateAfterLogin();
    }
}

const resetStateAfterLogin = () => {
    store.dispatch(resetAfterLogin());
}

const getAfterLoginKeys = () => {
    const state = store.getState().ads;
    const keys = {
        continue: state.continueAfterLogin,
        url: state.urlAfterLogin,
        props: state.propsAfterLogin,
    }
    return keys;
}

const isAfterLogin = () => {
    const afterLoginKeys = getAfterLoginKeys();
    if (isAdsEnable() && afterLoginKeys.continue && afterLoginKeys.url) {
        return true;
    }
    return false;
};

const getCampaign = (groupId, payeway_token) => {
  const request = new CampaignTask(groupId, payeway_token);
  const response = RequestManager.addRequest(request);

  return new Promise((resolve, reject) => {
    response
      .then((data) => {
        resolve(data.data.campaign);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/*
 * Solo cargar modulo tizen cuando la tv sea menor a 2020
 * TVs 2016 no funcionan con bitmovin y 2017 sí es necesario cargar modulo tizen
 */
const loadBitmovinTizenModule = function () {
    const devicePlatform = Device.getDevice().getPlatform();
    const userAgent = navigator.userAgent.toLowerCase();
    const isTizen = devicePlatform === 'tizen';
    const isTizen3_0 = isTizen && userAgent.indexOf('tizen 3.0') > -1; // 2017

    return isTizen3_0;
};

const isTVPlatformSupported = function() {
    const userAgent = navigator.userAgent.toLowerCase();
    const devicePlatform = Device.getDevice().getPlatform();
    let isSupported = {support: false, platform: devicePlatform};

    const isWebOS = devicePlatform === 'web0s';
    const isWebOS_1_x = isWebOS && userAgent.indexOf('applewebkit/537.4') > -1; // 2014
    const isWebOS_2_x = isWebOS && userAgent.indexOf('applewebkit/538.2') > -1; // 2015
    const isWebOS_3_x = isWebOS && userAgent.indexOf('chrome/38.') > -1; // 2016 & 2017
    if (isWebOS) {
        isSupported = { support: true, platform: 'web0s' };
    }

    /*
        Update 29 mayo 2024, se quita el soporte a WebOS 2017, ahora 2016 y 2017 no tienen soporte a bitmovin
        Ambos modelos-años comparten SDK 3.x.x
    */
    if (isWebOS_1_x || isWebOS_2_x || isWebOS_3_x) {
        isSupported = { support: false, platform: 'web0s' };
    }

    // https://developer.samsung.com/smarttv/develop/guides/fundamentals/retrieving-platform-information.html
    const isTizen = devicePlatform === 'tizen';
    const isTizen2_2 = isTizen && userAgent.indexOf('tizen 2.2') > -1; // 2015
    const isTizen2_4 = isTizen && userAgent.indexOf('tizen 2.4') > -1; // 2016
    // const isTizen3_0 = isTizen && userAgent.indexOf('tizen 3.0') > -1; // 2017
    if (isTizen) {
        isSupported = { support: true, platform: 'tizen' };
    }
    if (isTizen2_2 || isTizen2_4) {
        isSupported = { support: false, platform: 'tizen' };
    }

    // PS4 a stale
    const isPS4 = devicePlatform === 'ps4';
    if (isPS4) {
        isSupported = { support: false, platform: 'ps4' };
    }

    // Zeasn se va a stale
    const isZeasn = devicePlatform === 'zeasn';
    if (isZeasn) {
        isSupported = { support: false, platform: 'zeasn' };
    }

    /* Por el momento, netrange queda sin soporte bitmovin */
    const isNetrange = devicePlatform === 'netrange';
    if (isNetrange) {
        isSupported = { support: false, platform: 'netrange' };
    }

    const isHisense = devicePlatform === 'hisense';
    const isHisenseVidaa = isHisense && (userAgent.indexOf('vidaa') > -1
    || userAgent.indexOf('chrome/48') !== -1 // 2016 / 2017 Vidaa 2.5
    || userAgent.indexOf('chrome/59') !== -1 // 2017 / 2018 Vidaa 2.5
    || userAgent.indexOf('chrome/53') !== -1 // 2018 Vidaa 2.5
    || userAgent.indexOf('chrome/47') !== -1 // 2019 Vidaa 3.0
    || userAgent.indexOf('chrome/57') !== -1); // 2019 Vidaa 3.0
    // A partir del 2020 ya traen la palabra Vidaa en el User agent
    // Ejemplo hisense 2018 https://www.displayspecifications.com/en/model/44cb12d3/ con vidaa 2.5
    // https://www.vidaa.com/account/vidaa-docs/
    // sección de "web runtime -> kernel version"
    if (isHisenseVidaa) {
        isSupported = { support: true, platform: 'hisense' };
    }

    console.log('[BITMOVIN] isPlayerSupported? ', isSupported.support, isSupported);

    return isSupported;
};

  const validateClaroMusicNode = () => {
    const location = window.location.toString();

    const validation = location.indexOf("claromusica") !== -1 ||
    location.indexOf("playlist") !== -1 ||
    location.indexOf("album") !== -1 ||
    location.indexOf("radioList") !== -1 ||
    location.indexOf("artist") !== -1;

    return validation;
  }

const activeBitmovinPlayer = () => {
    const state = store && store.getState() ? store.getState().ads : {};
    const { currentContentType = AAF_CONTENT_IS_VOD } = state || {};

    const validateCurrentContentType = currentContentType === AAF_CONTENT_IS_VOD; //Valida que sea contenido VOD
    const isTVPlatformSupported = AdsUtils.isTVPlatformSupported(); //Se obtiene información de la plataforma
    const isDeviceWithBitmovin = isTVPlatformSupported.support; //Valida que la plataforma sea soportada
    const isClaroMusicNode = validateClaroMusicNode();

    return (
        !isClaroMusicNode && validateCurrentContentType &&
        isDeviceWithBitmovin
    )
};

const isUserFreemium = (usertype) =>{
    return usertype === Constants.FREEMIUM ? true : false;
}

const isUserNavPremium = (usertype) =>{
    return usertype === Constants.PREMIUM ? true : false;
}

const isFreemiumLogged = (usertype) =>{
    return usertype === Constants.FREEMIUMLOGGED ? true : false;
}

const isUserFreemiumOrFreemiumLoggedOrNavPremium = (usertype) => {
    return usertype === Constants.FREEMIUM || usertype === Constants.FREEMIUMLOGGED || usertype === Constants.PREMIUM ? true : false
}

const getUrlAds = (groupId, payway_token) => {
  const showBitmovin = activeBitmovinPlayer();
  const { publicity = "false" } = store.getState().ads || {};
  const validatePublicity = publicity === "true";

  showBitmovin && payway_token &&
  payway_token !== "" &&
  validatePublicity &&
  getCampaign(groupId, payway_token)
  .then((response) => {
    store.dispatch(setUrlAds(response));
  }).catch((error) => {
    store.dispatch(setUrlAds({url: ""}));
  });
}

const updateStorePublicityData = (groupId) => {
  const showBitmovin = activeBitmovinPlayer();
  showBitmovin && getContentData(groupId)
  .then((contentData) => {
    const { group: {
      common: {
        publicity = 'false',
        rolls = {}
      } = {}
    } = {}
    } = contentData || {};

    store.dispatch(setContentDataPublicity({
      publicity,
      rolls,
      currentContentType: AAF_CONTENT_IS_VOD,
    }));

  }).catch(() => {

    store.dispatch(setContentDataPublicity({
      publicity: 'false',
      rolls: {},
      currentContentType: "",
    }));

  });
};

const updateStoreAutoChangeEpisode = (groupId, payway_token) => {
    return new Promise((resolve, reject) => {
      try {
        updateStorePublicityData(groupId)
        getUrlAds(groupId, payway_token)
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

const findNodeToRedirect = (history, nodes, node_id, oneoffertype, producttype, groupId) => {
    let nodeCode = '';
    const type = contentType(oneoffertype, producttype);
    nodes.map((node) => {
        if(node.id === node_id) {
            nodeCode = node.code;
        } else {
            if(node.code === 'playandgo') {
                node.childs.map((child) => {
                    if(child.id === node_id) {
                        nodeCode = child.code;
                    }
                });
            }
        }
    });
    nodeCode = nodeCode ? nodeCode : nodes[0].code;
    if (type !== '' && type !== undefined && (type === RENT || type === BUY)) {
        history.replace(`/vcard/${groupId}`);
    } else {
        history.replace(`/node/${nodeCode}`);
    }

}

const contentType = (oneoffertype, producttype) => {
    //TODO: mejorar la distincion de compra-renta-suscripcion
    if (oneoffertype.toLowerCase().includes('buy')) {
        if (producttype.toLowerCase().includes('season')) {
            return 'buy';
        } else if (producttype.toLowerCase().includes('episode')) {
            return 'buy';
        } else {
            return 'buy';
        }
    } else if (oneoffertype.toLowerCase().includes('rent')) {
        return 'rent';
    }
    else if (oneoffertype.toLowerCase().includes('subscription') || oneoffertype.toLowerCase().includes('subscrition')) {
        return 'subscription';
    }
}
const transformResponsePBIToAds = async (pbi, groupId, saveStore = true) => {
  const changeInfoPBI = pbi
  const { playFreemiumButton = {} } = pbi || {};
  const havePlayFreemiumButton = playFreemiumButton && playFreemiumButton.visible === "1"

  /**
   *Se sobre escribe valor de playButto con playFreemiumButton para que sea transparente la reproducción
   */

  if(havePlayFreemiumButton) {
    changeInfoPBI.playButton = playFreemiumButton
    saveStore && store.dispatch(setKindOfPlayButtonAds({ playFreemiumButton }))
  }
  else {
    saveStore && store.dispatch(setKindOfPlayButtonAds({playFreemiumButton: {visible: "0"}}))
  }

  const { playButton: {payway_token = ""} = {} } = changeInfoPBI || {};

  if(saveStore) await getUrlAds(groupId, payway_token)

  return changeInfoPBI
};

const AdsUtils = {
    isAdsEnable,
    getUserType,
    getSkipOffSet,
    getexperience_hour_refresh,
    loadUserType,
    redirectToLogin,
    redirectToRoot,
    recibeProps,
    getProps,
    resetStateAfterLogin,
    getAfterLoginKeys,
    isAfterLogin,
    isUserFreemium,
    isFreemiumLogged,
    activeBitmovinPlayer,
    loadBitmovinTizenModule,
    isTVPlatformSupported,
    getUrlAds,
    updateStoreAutoChangeEpisode,
    isUserNavPremium,
    isUserFreemiumOrFreemiumLoggedOrNavPremium,
    findNodeToRedirect,
    transformResponsePBIToAds,
    contentType,
    redirectToRootRegister
};

export { AdsUtils };



// WEBPACK FOOTER //
// ./src/AAF/Ads/Utils.js